import { Component, OnInit, Output, EventEmitter, inject } from '@angular/core';
import { MemberInfoService } from '../../services/member-info.service';
import { Member } from '../../services/models/member';
import { MemberRequest } from '../../services/models/member-request';
import { MemberStatusMap } from '../../services/models/member-status-map';
import { catchError, of, tap } from 'rxjs';
import { SelectItem } from 'primeng/api';
import { SessionService } from 'src/app/services/session.service';
import { MemberEligibilityStatus } from 'src/app/services/models/member-eligibility-status';

@Component({
  selector: 'app-member-results',
  templateUrl: './member-results.component.html',
  styleUrls: ['./member-results.component.scss']
})
export class MemberResultsComponent implements OnInit {
  private memberService = inject(MemberInfoService);
  private sessionService = inject(SessionService);

  public emptyListMessage: string = null;
  public selectedmember: Member;
  public sortColumn = 'name';
  public sortAscending = true;
  public totalMembers = 0;
  readonly sortOptions: SelectItem[] = [
    {label: 'Eligibility Status', value: 'eligibilityStatus'},
    {label: 'Effective Date', value: 'healthNetworkPlanEffectiveDate'},
    {label: 'Gender', value: 'gender'},
    {label: 'Line of Business', value: 'lineOfBusiness'},
    {label: 'Health Network', value: 'healthNetworkPlanCode'},
    {label: 'PCP', value: 'pcp'},
  ];
  public sortField: string;
  public sortOrder: number;
  public sortKey: SelectItem;
  public gender: string;
  public showDialog: boolean = false;
  public today = new Date().toISOString();

  public memberListData$ = this.memberService.memberListChanged$
  .pipe(
    tap((data) => {
      if (data) {
        this.sortField = undefined;
        console.debug("memberListChanged$", data);
      }
    }),
    catchError(() => {
      this.emptyListMessage = 'Too many members found.  Please refine your search!';
      return of(new MemberRequest());
    }),
  );

  @Output() memberSelected = new EventEmitter<boolean>();

  ngOnInit() {
    this.sortKey = this.sortOptions[0];
  }

  public rosterEnabled(member:Member): boolean {
    if(member && (member.eligibilityStatus == MemberEligibilityStatus.Eligible || member.eligibilityStatus == MemberEligibilityStatus.SharedCost)) {
      if(this.sessionService.isInternalUser) {
        return true;
      }
      else {
        const itemexists = this.sessionService.currentPermission.userPermissionCodes.find(x=> x.trim().toUpperCase() === "PRVBRM");
        return itemexists ? true : false;
      }
    }
    else {
      return false;
    }
  }

  //Default sorting method
  public onSortInit(){
    if(this.sortField == undefined){
    this.sortField = 'eligibilityStatus';
    this.sortOrder = -1;}
  }

  public onSortChange(event) {
    const value = event.value;
    if (value === 'eligibilityStatus') {
      this.sortOrder = -1;
    }
    else  {
      this.sortOrder = 1;
    }
    this.sortField = value;
  }

  public sortClass(column: string): string {
    let cls: string;
    if (column === this.sortColumn) {
      cls = this.sortAscending ? 'fa fa-chevron-up' : 'fa fa-chevron-down';
    }
    else {
      cls = 'fa fa-chevron-up';
    }
    return cls;
  }

  public onSort(event: any): void {
  }

  // Get the class(es) to display for the status icon
  public mapStatusToIcon(member: Member): string {
    return MemberStatusMap.mapStatustoIcon(member.eligibilityStatus);
  }

  // Get the string to display for the tooltip (title) for the user hovers over the status icon
  public mapStatusToTooltip(member: Member): string {
    return MemberStatusMap.mapStatusToSelectItem(member.eligibilityStatus).label;
  }

  public mapStatusToTitle(member: Member): string {
    return MemberStatusMap.mapStatusToSelectItem(member.eligibilityStatus).title;
  }

  public mapStatusToColor(member: Member): string {
    return MemberStatusMap.mapStatusToSelectItem(member.eligibilityStatus).styleClass;
  }

  public onDetailClicked(event, row: Member) {
      this.memberService.setSelectMember(row);
      let result = true;
      this.memberSelected.emit(result);
  }

  public onRosterClicked(event, row: Member) {
    this.selectedmember = row;
    this.showDialog = true;
  }

  public onCancelRosterDialog() {
    this.showDialog = false;
  }
}
